import {connect} from 'react-redux';

import {AppPanelId, makeLegacyPanelId} from '../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapStateToProps} from '../../../srcCommon/helpers/reselectHelpers';
import {getCompanyUrl} from '../../store/data/company/companySelectors';
import {makeGetOptionalLegacyPath} from '../../store/panels/legacy/legacyPanelSelectors';
import {LegacyFrame} from './legacyFrame';

/*
 * Props.
 */

interface LegacyFrameContainerProps {
  panelId: AppPanelId;
}

/*
 * Selectors.
 */

function getLegacyPanelId(_state: unknown, props: LegacyFrameContainerProps) {
  return makeLegacyPanelId(props.panelId);
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<LegacyFrameContainerProps>()(() => ({
  legacyPath: makeGetOptionalLegacyPath(getLegacyPanelId),
  companyUrl: getCompanyUrl,
}));

export const LegacyFrameContainer = connect(mapStateToProps)(LegacyFrame);
